/**
 * html直接插入的组件
 */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

class HtmlRegion extends PureComponent {
    static propTypes = {
        content: PropTypes.string,
    };
    createHtml = () => {
        return { __html: this.props.content };
    };
    render() {
        return <div dangerouslySetInnerHTML={this.createHtml()} />;
    }
}

export { HtmlRegion };
export default HtmlRegion;
